<template>
  <div class="h-100 d-flex flex-column">
    <div class="d-flex align-items-center justify-content-between px-2 py-2 border-bottom bg-white">
      <div class="font-weight-bold">{{ title }}</div>
      <div class="d-flex align-items-center">
        <el-popover placement="left" trigger="manual" content="data Copied" v-model:visible="copyVisible">
          <template #reference>
            <button class="btn btn-sm btn-primary mr-2" type="button" @click="copyTable">
              Copy
            </button>
          </template>
        </el-popover>
        <button class="btn btn-sm btn-primary mr-2" type="button" @click="downloadCsv">Download</button>
        <button type="button" class="btn btn-sm btn-outline-secondary" title="Close" aria-label="Close"
          @click="$emit('close')">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true">
            <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
      </div>
    </div>
    <div class="flex-grow-1 overflow-auto">
      <table class="table table-sm table-hover mb-0">
         <thead class="thead-light sticky-top bg-light">
          <tr>
            <th>Date</th>
            <th class="text-right">Open</th>
            <th class="text-right">High</th>
            <th class="text-right">Low</th>
            <th class="text-right">Close</th>
            <th v-for="c in columns" :key="c.key" class="text-right">
              {{ c.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(r, idx) in rows" :key="r.t || idx">
            <td>{{ formatTime(r.t) }}</td>
            <td class="text-right">{{ fmt(r.o) }}</td>
            <td class="text-right">{{ fmt(r.h) }}</td>
            <td class="text-right">{{ fmt(r.l) }}</td>
            <td class="text-right">{{ fmt(r.c) }}</td>
            <td v-for="c in columns" :key="c.key" class="text-right">
              {{ r[c.key] != null ? fmt(r[c.key]) : "" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { ElPopover } from "element-plus";
export default {
  name: "CandlesTable",
  props: {
    title: { type: String, default: "SYMBOL" },
    rows: { type: Array, default: () => [] },
    columns: { type: Array, default: () => [] },
  },
  data() {
    return {
      copyVisible: false,
      copyTimer: null,
    };
  },
  beforeUnmount() { 
    if (this.copyTimer) clearTimeout(this.copyTimer);
  },
  methods: {
    fmt(v) {
      if (v == null || Number.isNaN(Number(v))) return "";
      return Number(v).toFixed(2);
    },
    formatTime(t) {
      const d = typeof t === "number" ? new Date(t) : new Date(String(t));
      if (Number.isNaN(d.getTime())) return String(t ?? "");
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yy = String(d.getFullYear()).slice(-2);
      const hh = String(d.getHours()).padStart(2, "0");
      const mi = String(d.getMinutes()).padStart(2, "0");
      return `${dd}/${mm}/${yy} ${hh}:${mi}`;
    },
    buildTsv() {
      const header = ["Date", "Open", "High", "Low", "Close", ...this.columns.map(c => c.label)].join("\t");
      const lines = (this.rows || []).map(r => {
        const base = [this.formatTime(r.t), this.fmt(r.o), this.fmt(r.h), this.fmt(r.l), this.fmt(r.c)];
        for (const c of this.columns) base.push(r[c.key] != null ? this.fmt(r[c.key]) : "");
        return base.join("\t");
      });
      return [header, ...lines].join("\n");
    },
    async copyTable() {
      const text = this.buildTsv();
      let ok = false;
      try {
        await navigator.clipboard.writeText(text);
        ok = true;
      } catch {
        try {
          const ta = document.createElement("textarea");
          ta.value = text;
          document.body.appendChild(ta);
          ta.select();
          document.execCommand("copy");
          document.body.removeChild(ta);
          ok = true;
        } catch {
          ok = false;
        }
      }
      if (!ok) return;
      this.copyVisible = true;
      if (this.copyTimer) clearTimeout(this.copyTimer);
      this.copyTimer = setTimeout(() => {
        this.copyVisible = false;
      }, 1200);
    },
    downloadCsv() {
      const header = ["Date", "Open", "High", "Low", "Close", ...this.columns.map(c => c.label)].join(",");
      const lines = (this.rows || []).map(r => {
        const base = [`"${this.formatTime(r.t)}"`, this.fmt(r.o), this.fmt(r.h), this.fmt(r.l), this.fmt(r.c)];
        for (const c of this.columns) base.push(r[c.key] != null ? this.fmt(r[c.key]) : "");
        return base.join(",");
      });
      const csv = [header, ...lines].join("\n");
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "candles.csv";
      a.click();
      URL.revokeObjectURL(url);
    },
  },
};
</script>
